import { DEFAULT_FILE_SIZE_UPLOAD_LIMIT } from "@/components/utils/Constants";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { SvgIconProps } from "@mui/material";
import React from "react";

type MuiIcon = React.ComponentType<SvgIconProps>;

export const downloadFileFromPreSignedUrl = (url: string, fileName: string): void => {
  const a = document.createElement("a");
  document.body.append(a);
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();
};

export const getValidFiles = (files: File[], sizeLimit?: number): File[] => {
  const maxSize = sizeLimit ?? DEFAULT_FILE_SIZE_UPLOAD_LIMIT;
  const maxSizeInMB = (maxSize / (1024 * 1024)).toFixed(0);

  return files.filter((f) => {
    if (f.size < maxSize) {
      return true;
    } else {
      NotificationService.error(`${f.name} exceeded max size allowed (${maxSizeInMB} MB)`);
      return false;
    }
  });
};

export const getFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex <= 0) return "";
  return filename.slice(lastDotIndex + 1).toLowerCase();
};

export const getFileIcon = (filename: string, props: SvgIconProps = {}) => {
  const extension = getFileExtension(filename).toLowerCase();

  const iconMap: Record<string, MuiIcon> = {
    jpg: ImageIcon,
    jpeg: ImageIcon,
    png: ImageIcon,
    gif: ImageIcon,
    webp: ImageIcon,
    svg: ImageIcon,
    pdf: PictureAsPdfIcon,
    doc: DescriptionIcon,
    docx: DescriptionIcon,
    txt: DescriptionIcon,
    csv: DescriptionIcon,
  };

  const SelectedIcon: MuiIcon = iconMap[extension] ?? InsertDriveFileIcon;

  return React.createElement(SelectedIcon, props);
};
